import React from 'react';
import { i18next } from '@yola/ws-sdk';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import segment from 'src/js/modules/analytics/segment';
import getPMFSurveyUrl from 'src/js/modules/config/selectors/pmf-survey-url';
import dialogs from 'yola-editor/src/js/modules/dialogs';
import GenericDialog from 'yola-editor/src/js/modules/dialogs/components/generic-dialog';
import dialogTypes from 'yola-editor/src/js/modules/dialogs/constants/dialog-types';
import getLocale from 'yola-editor/src/js/modules/i18n/selectors/locale';
import user from 'yola-editor/src/js/modules/user';
import helpers from '../../helpers';

const {
  trackers: { trackEvent },
  constants,
} = segment;

function SurveyDialogContainer({ onDialogMainAction, onDialogCancel }) {
  const captions = {
    title: i18next.t('Help us improve our product!'),
    content: i18next.t(
      'Please take a quick, 2-minute survey and let us know how we can help you be more successful online'
    ),
    secondaryAction: i18next.t('Remind me later'),
    mainAction: i18next.t('Take a survey'),
  };

  const dispatch = useDispatch();
  const userData = useSelector(user.selectors.getUserData);
  const locale = useSelector(getLocale);
  const url = useSelector(getPMFSurveyUrl);
  const link = helpers.generatePMFSurveyLink(url || '', userData.id, locale);

  const closeDialog = () => dialogs.operations.hide();

  const handleDisplaySurvey = () => {
    onDialogMainAction();

    trackEvent(constants.events.PMF_SURVEY_DISPLAYED);

    const thankYouDialogProps = {
      captions: {
        mainAction: i18next.t('Close'),
      },
      onMainAction: closeDialog,
      onClose: closeDialog,
    };

    dialogs.operations.show(dialogTypes.SURVEY_THANK_YOU, thankYouDialogProps);
  };

  const handlePostponeSurvey = () => {
    onDialogCancel();

    trackEvent(constants.events.PMF_SURVEY_POSTPONED);

    dispatch(
      user.actions.updateUserPreference(
        user.preferences.PMF_STATUS_UPDATE_AT,
        helpers.getCurrentDateTime()
      )
    );

    closeDialog();
  };

  return (
    <GenericDialog
      captions={captions}
      mainActionLink={link}
      onMainAction={handleDisplaySurvey}
      onSecondaryAction={handlePostponeSurvey}
      onClose={handlePostponeSurvey}
    >
      <span className="dialog-body__emoji" role="img" aria-label="Waving Hand">
        &#x1f44b;
      </span>
      <h5 className="dialog-body__title">{captions.title}</h5>
      <p className="dialog-body__content">{captions.content}</p>
    </GenericDialog>
  );
}

SurveyDialogContainer.propTypes = {
  onDialogMainAction: PropTypes.func.isRequired,
  onDialogCancel: PropTypes.func.isRequired,
};

export default SurveyDialogContainer;
